import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendComparisonSet,
  BackendMutationPerformanceCenterCalculateBenchmarkModelArgs,
} from 'src/types/backend';

import { COMPARISON_SET_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation PerformanceCenterCalculateBenchmarkModel(
    $customerId: ID!
    $accountId: ID!
    $dataSource: PerformanceCenterDataSource!
    $name: String!
    $description: String!
    $assetType: String!
  ) {
    performanceCenterCalculateBenchmarkModel(
      customerId: $customerId
      accountId: $accountId
      dataSource: $dataSource
      name: $name
      description: $description
      assetType: $assetType
    ) {
      ...ComparisonSet
    }
  }
  ${COMPARISON_SET_FRAGMENT}
`;

type Variables = BackendMutationPerformanceCenterCalculateBenchmarkModelArgs;
type Result = BackendComparisonSet[];

export const performanceCenterCalculateBenchmarkModel = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
